<template>
  <div v-if="data_student.length > 0" id="stud_main">
  





<div id="mySidebar" class="sidebar" style="margin-top:2.1em;">
<div class="box is-radiusless has-background-grey-dark" style="margin-bottom:0em;">
<div class="columns is-multiline has-background-grey-dark has-text-white">

<div class="column is-12 colBorder"><a class="button is-fullwidth" @click="sortNav()">Menu&nbsp;&nbsp;<span class="icon is-small"><i class="fas fa-angle-double-left"></i></span></a></div>

<div @click="sort_menu('DETAILS')" class="column is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-home"></i></span> &nbsp;Accueil </div>
<div v-if="access_notes" @click="sort_menu('COURSES')" class="column is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-list"></i></span> &nbsp;Cours </div>
<div @click="sort_menu('SCHEDULE')" class="column is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-calendar-alt"></i></span> &nbsp;Horaire </div>
<div @click="sort_menu('PAIMENT')" class="column is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-money-check-alt"></i></span> &nbsp;Paiements </div>

</div>
</div>


<!--   <a>--------------</a>
  <a @click="logout"><span class="icon"><i class="fas fa-sign-out-alt"></i></span> &nbsp;Log out</a>
  --> 
</div>
<!-- END SIDEBAR  -->


<div class="columns is-mobile is-vcentered is-gapless has-background-grey-dark" style="margin-top:-1.6em;margin-bottom:0em;" >
<div class="column" :class="return_column_width('is-2','is-4')"><a class="button is-borderless is-fullwidth has-background-grey-dark has-text-white" @click="sortNav()"><span class="icon is-small"><i class="fas fa-angle-double-right"></i></span>&nbsp;&nbsp;Menu</a></div>
<div class="column has-text-right is-size-7 has-text-weight-bold has-text-light" :class="return_column_width('is-10','is-8')">{{return_user()}}&nbsp;&nbsp;</div>  
</div> 

<div id="mainContent">

<!-- STUD!!!!  -->

<div v-if="active_view == 'DETAILS'" class="columns is-centered">
<!-- NAME  -->
<div class="column box" :class="return_column_width('is-10','is-11')">
<div class="columns is-gapless is-mobile is-multiline" style="margin-left:.4em;">
    <div class="column is-6 isLabel">Nom</div>
    <div class="column is-6 isLabel">Prenom</div>
    <div class="column is-6">
        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_lNAME" class="input is-uppercase is-size-5 is-fullwidth has-text-weight-semibold" placeholder="Nom ">
    </div>
    <div class="column is-6">
        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_fNAME" class="input is-uppercase is-size-5 is-fullwidth has-text-weight-semibold" placeholder="Nom ">
    </div>

<!-- WARNING !!!! -->
<div v-if="!access_notes" style="margin-top:2em;" class="column is-12 is-size-6 has-text-weight-bold has-text-centered colNotes">
Notez que tout étudiant ayant un compte en souffrance à la date limite du paiement des frais de scolarité, se verra refusé l’accès au portail, ne pourra obtenir de documents officiels, ni se réinscrire à la prochaine session jusqu’à ce que son compte soit acquitté. Aussi, l’accès peut être bloqué si l’école est en attente d’un document officiel requis pour l’admission au Collège.
</div>

<!-- ADDRESS  -->
    <div class="column is-12 isLabel">Adresse</div>
    <div class="column is-12">
        <input :disabled="!enabled" @change="something_changed()" :value="return_address()" class="input is-uppercase is-fullwidth has-text-weight-semibold" placeholder="Adresse ">
    </div>
 <!-- :class="return_text_size('is-size-5','is-size-7')" -->


<!-- PHONE(s) / EMAIL  -->
<div class="column is-12">
<div class="columns is-gapless is-mobile is-multiline" style="margin-left:.4em;">

    <div class="column is-6 isLabel">Tel. Cell</div>
    <div class="column is-6 isLabel">Tel. Autre</div>

    <div class="column is-6">
        <input v-mask="'(###) ###-####'" :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_TelOther" class="input is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Cellulaire ">
    </div>

    <div class="column is-6">
        <input v-mask="'(###) ###-####'" :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_TelHome" class="input is-fullwidth has-text-weight-semibold has-text-centered" placeholder="Autre ">
    </div>

    <div class="column is-12 isLabel" style="margin-top:.5em;">Courriel</div>
    <div class="column is-12" style="">
    <div class="control has-icons-left has-icons-right">
    <span class="icon is-left"><i class="fas fa-envelope fa-lg"></i></span>

        <input :disabled="!enabled" @change="something_changed()" v-model="data_student[0].student_eMail" class="input is-fullwidth has-text-weight-semibold" placeholder="Courriel ">
    </div></div>

</div></div>

<!-- <div v-if="access_notes" class="columns is-mobile"> -->
<!-- DO THIS !!!! ok -->

 <!-- CHECK IF SHOWING TAX SLIPS -->
<div class="column is-12" :class="chkAccess()" style="margin-top:2em;">
<div class="columns is-mobile">

<div v-if="check_show_tax_slips()" @click="download_slip('RL8-'+data_student[0].student_lNAME.trim().toUpperCase()+', '+data_student[0].student_fNAME.trim().toUpperCase()+ '-' +data_student[0].student_CodePerm.trim().toUpperCase()+'.pdf')" class="column isLink is-size-7 has-text-left" :class="return_column_width('is-2','is-4')" style="margin-top:0em;"><span class="icon"><i class="fab fa-quora"></i></span> &nbsp;RL8 - 2021 </div>
<div v-if="check_show_tax_slips()" @click="download_slip('T2202-'+data_student[0].student_lNAME.trim().toUpperCase()+', '+data_student[0].student_fNAME.trim().toUpperCase()+ '-' +data_student[0].student_CodePerm.trim().toUpperCase()+'.pdf')" class="column isLink is-size-7 has-text-left" :class="return_column_width('is-2','is-4')" style="margin-top:0em;"><span class="icon"><i class="fab fa-canadian-maple-leaf"></i></span> &nbsp;T2202 - 2021 </div>

<div v-if="show_files" @click="download_slip(doc_bulletin)" class="column isLink is-size-7 has-text-centered" :class="return_column_width('is-2','is-4')" style="margin-top:0em;"><span class="icon"><i class="fas fa-print"></i></span> &nbsp;BULLETIN </div>
<div v-if="show_files" @click="download_slip(doc_invoice)" class="column isLink is-size-7 has-text-centered" :class="return_column_width('is-2','is-4')" style="margin-top:0em;"><span class="icon"><i class="fas fa-print"></i></span> &nbsp;INVOICE </div>

</div>
</div>









</div>
</div>
</div>
<!-- END DETAILS VIEW -->



<div v-if="active_view == 'COURSES'" class="columns is-centered">
<div class="column box" :class="return_column_width('is-10','is-11')">
<CompCourses 
  :student_id="data_student[0].student_ID"
> </CompCourses>
</div></div>


<div v-if="active_view == 'SCHEDULE'" class="columns is-centered">
<div class="column box" :class="return_column_width('is-12','is-12')">
<Calendar :events="data_events" style="margin-top:0em;"
> </Calendar>
</div></div>

<div v-if="active_view == 'PAIMENT'" class="columns is-centered">
<div class="column box" :class="return_column_width('is-10','is-11')">
<CompPaiments 
  :student_id="data_student[0].student_ID"
> </CompPaiments>
</div></div>

</div>

  </div>
</template>


<script>
import axios from 'axios';
import moment from 'moment'
import  CompCourses  from '@/views/Student/Courses'
//import  CompSchedule  from '@/views/Student/Schedule'
import  CompPaiments  from '@/views/Student/Paiments'

import Calendar from '@/components/Comp_Calendar'

export default {
  components: { CompCourses ,  CompPaiments , Calendar},

  data: function() {
    return {
      data_student: '',
      navOpen:false,

active_college : sessionStorage.getItem('college') ,


show_main :true,
show_schedule :false,
show_courses :false,
show_paiment :false,

access_notes: true,

show_password:false,
password_error:'',
pass1:'',
pass2:'',

show_files:false , // SHOW FILES FOR ESJQ
doc_path:'https://space-zytco.nyc3.digitaloceanspaces.com/ESJQ/',
doc_bulletin:'',
doc_invoice:'',

 data_events: [],

active_view : "DETAILS",
enabled: false,
isMobile: false, 
screenWidth: screen.width,

    }
  },
// END DATA

mounted() {
    window.onresize = () => {
        this.screenWidth = window.innerWidth
    }
},



created() {


// CHECK IF MOBILE !!!!
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    this.isMobile = true;
}


var query = "SELECT *,CAST(IIF ( student_webNoNotes = 1, 1, 0 ) AS BIT) as noAccess  FROM myMEQ_STUDENT WHERE student_ID = "  + sessionStorage.getItem('user_ID') 
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + query)
.then(res => {
    this.data_student = res.data 



// GET SCHEDULE HERE !!!! ---- ONLY PASS EVENTS
  var query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS, MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
  ,MyMEQ_COUR.cour_TITRE_F FROM  myMEQ_SCHEDULE_MAIN INNER JOIN MyMEQ_COURSESTUDENT ON myMEQ_SCHEDULE_MAIN.group_ID = MyMEQ_COURSESTUDENT.group_ID 
  LEFT OUTER JOIN MyMEQ_GROUP on MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID LEFT OUTER JOIN MyMEQ_COUR on MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID 
  LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID 
  WHERE student_ID = ` + sessionStorage.getItem('user_ID') + `  ORDER BY schedMain_AmPmSoir` 
console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        var i;
        for (i = 0; i < res.data.length; i++) {

var desc = "<div class='columns is-gapless is-multiline'>"
desc += "<div class='column is-12 is-size-6 has-text-weight-bold'> " + res.data[i].cour_TITRE_F + " </div>"
desc += "<div class='column is-12'> " + res.data[i].prof + " </div>"
desc += "<div class='column is-9'> " + res.data[i].schedRoom_CAMPUS + " </div>"
desc += "<div class='column is-3 is-size-5 has-text-weight-bold has-text-centered' style='margin-top:-.5em;'> " + res.data[i].schedRoom_DESC  + "</div>"
desc += "<div>"

          this.data_events.push( 
            { 
              id:res.data[i].schedMain_ID,
              course:res.data[i].cour_TITRE_F,
              title: desc, //res.data[i].schedMain_AmPmSoir + " <br> " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF + " --" + res.data[i].schedMain_ID,
              details: 'COUR : ' + res.data[i].schedMain_CODE_COUR + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
              date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
              open: false,
              class:'my-event',
              color: res.data[i].schedMain_COLOUR,
              hour:res.data[i].schedMain_AmPmSoir
            })
        }  // END FOR

        // CHECK ESJQ 'ESJQ/' +
        if (sessionStorage.getItem('url_query') == '/query_general_ESJ') {
            this.show_files = true
            this.doc_bulletin =  this.data_student[0].student_lNAME.toUpperCase() + '-' + this.data_student[0].student_CodePerm.toUpperCase() + '.PDF'
            var invID = this.data_student[0].student_InvoiceID
            invID = invID - 1
            this.doc_invoice = this.data_student[0].student_SecretCode.toUpperCase() + '-' +  invID + '.PDF'
        }

        // CHECK IF NO ACCESS TO NOTES
        if (this.data_student[0].noAccess == 1) {this.access_notes = false}
})

})

},

  methods: {

sort_menu:function(view) {
    if (this.isMobile) {this.closeNav()}
    this.active_view = view
},

return_column_width(colD, colM) {
  if (this.isMobile) 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
  if (this.isMobile) 
  {return sizeM} else {return sizeD} 
},


// TAX SLIPS ------------
check_show_tax_slips() {
  if (sessionStorage.getItem('url_query') == '/query_general_AEQ' || sessionStorage.getItem('url_query') == '/query_general_CAF' || sessionStorage.getItem('url_query') == '/query_general_ESJ' || sessionStorage.getItem('url_query') == '/query_general_MUSI') 
    { return true } else { return false } 
},
download_slip(slip){

  axios({
    url: this.$url+'/get_file?filename='+slip,
    method: 'GET',
    responseType: 'blob', // important
    }).then((response) => {
console.log(response.data)
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', slip);
    document.body.appendChild(link);
    link.click();
  })
  .catch(function (error) {
    if (error.response) {
      alert('Fichier non disponible')
    }
  });
},



save_password() {
  this.password_error = ''

    if (!this.pass1 || !this.pass2) {this.password_error = 'Enter New Password'; return}
    if (this.pass1 != this.pass2) {this.password_error = 'Passwords Do Not Match'; return}


    var sql = "UPDATE myMEQ_STUDENT SET student_webPass = '" + this.pass1 + "' WHERE student_ID = " + sessionStorage.getItem('user_ID')
    sql += ";SELECT student_ID FROM myMEQ_STUDENT WHERE student_ID = "  + sessionStorage.getItem('user_ID') 
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => {
          this.show_password=false 
    })

  
},



chkAccess:function(){
if (this.access_notes == false) 
    {return 'disabledDiv' } else { return ''  }
},



logout:function() {
        sessionStorage.removeItem('user_ID')
        sessionStorage.removeItem('isGood')
        sessionStorage.removeItem('user_level')
        this.$router.push({ name: 'main' });  
},

return_user() {
  return sessionStorage.getItem('user_name')
},

return_address:function() {
    var address = ''
    if (this.data_student[0].student_apt) {address += '#' + this.data_student[0].student_apt + "-"}
    address += this.data_student[0].student_rueNUM + ' ' + this.data_student[0].student_Address
    address += ', ' + this.data_student[0].student_City + ' ' + this.data_student[0].student_Postal
    return address.replace(/null/g,"")
},

sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},

openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true
},

/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false
},



      chkLoggedIn:function(){
        if (sessionStorage.getItem('isGood') === null) {return false } else { return true  }
      },
  }
}
</script>




<style scoped>

.disabledDiv {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
}




</style>
